import { humanTimeDistance, zeroPadTimeSegment } from 'bv-helpers/datetime';

export const getTimer = (startTime) => {
  const { hours, minutes, seconds } = humanTimeDistance(startTime, { daysAsHours: true });

  return (
    hours ? [hours, minutes, seconds] : [minutes, seconds]
  ).map(zeroPadTimeSegment).join(':');
};
